import { ActiveConfiguration } from '@icc/shared/types';
import { CoupledWindowConfiguration } from './coupled-window-configuration';
import { PriceSegment, DiscountGroups, PricePart } from '@icc/price/b2b';
import { IConfiguratorsDataService } from '@icc/shared/types';
import { CouplingActive, SideProfileActive, Profile, WindowParameters } from '@icc/window-door/types';
import { WindowInCoupling, RollerShutterInCoupling } from '../elements/coupled-window';
import { Accessory } from '@icc/construction-elements/types';
import { RollerShutter } from '@icc/shutter/types';
import { Sill } from '@icc/window-door/types';

export class CoupledWindowActiveConfiguration implements ActiveConfiguration {
    public static is(configuration): configuration is CoupledWindowActiveConfiguration {
        return (
            configuration instanceof CoupledWindowActiveConfiguration
            || (!configuration.$version && configuration.type === 'coupled_window')
        );
    }
    _id?: string = null;
    type: 'coupled_window' = 'coupled_window';
    Name: string = '';
    Price: number = 0;
    ListPrice: number = 0;
    PriceNoMargin: number = 0;
    ListPriceNoMargin: number = 0;
    PriceAfterDiscountsInCurrency: number = 0;
    ListPriceAfterDiscountsInCurrency: number = 0;
    PriceBeforePromotions: number = 0;
    ListPriceBeforePromotions: number = 0;
    PriceGross: number = 0;
    ListPriceGross: number = 0;
    PriceGrossAfterDiscounts: number = 0;
    ListPriceGrossAfterDiscounts: number = 0;
    PriceGrossBeforePromotions: number = 0;
    ListPriceGrossBeforePromotions: number = 0;
    Quantity: number = 1;
    Issues: any[] = [];
    PriceSegments: PriceSegment[] = [];
    ListPriceSegments: PriceSegment[] = [];
    PriceSegmentsNoMargin: PriceSegment[] = [];
    ListPriceSegmentsNoMargin: PriceSegment[] = [];
    PriceSegmentsBeforePromotions: PriceSegment[] = [];
    ListPriceSegmentsBeforePromotions: PriceSegment[] = [];
    PriceParts: PricePart[] = [];
    ListPriceParts: PricePart[] = [];
    PricePartsNoMargin: PricePart[] = [];
    ListPricePartsNoMargin: PricePart[] = [];
    PricePartsBeforePromotions: PricePart[] = [];
    ListPricePartsBeforePromotions: PricePart[] = [];
    DiscountGroups: DiscountGroups = {};
    DiscountGroupsNoMargin: DiscountGroups = {};
    Discount: number = 0;
    ListDiscount: number = 0;
    Title = '';
    Description = '';
    Attachments = [];
    valid: {} = {};
    PriceValid = false;
    drawData: any;
    timestamp: Date | number = undefined;
    parameters: WindowParameters = {
        weight: null,
    };

    height: number = 1500;
    width: number = 1500;
    windows: WindowInCoupling[] = [];
    couplings: CouplingActive[] = [];
    sideProfiles: SideProfileActive[] = [];
    sideAccessories: Accessory[] = [];
    rollerShutters: RollerShutterInCoupling[] = [];
    windowSills: Sill[] = [];

    usedProfiles: Profile[] = [];

    detachedPositions: string[] = [];
    removedPositions: string[] = [];

    attributes: {
        id: string;
        name: string;
        value: string;
        valueId?: number;
    }[] = [];

    System: any = {};

    constructor(configuration?, private configuratorsDataService?: IConfiguratorsDataService) {
        if (configuration) {
            if (CoupledWindowActiveConfiguration.is(configuration)) {
                for (const propName in configuration) {
                    if (this.hasOwnProperty(propName)) {
                        this[propName] = configuration[propName];
                    }
                }
            } else {
                if (CoupledWindowConfiguration.is(configuration) && configuratorsDataService) {
                    this.Name = configuration.name;
                    this.Price = configuration.price;
                    this.ListPrice = configuration.listPrice;
                    this.PriceNoMargin = configuration.priceNoMargin;
                    this.ListPriceNoMargin = configuration.listPriceNoMargin;
                    this.PriceAfterDiscountsInCurrency = configuration.priceAfterDiscountsInCurrency;
                    this.ListPriceAfterDiscountsInCurrency = configuration.listPriceAfterDiscountsInCurrency;
                    this.PriceGross = configuration.priceGross;
                    this.ListPriceGross = configuration.listPriceGross;
                    this.PriceGrossAfterDiscounts = configuration.priceGrossAfterDiscounts;
                    this.ListPriceGrossAfterDiscounts = configuration.listPriceGrossAfterDiscounts;
                    this.Quantity = configuration.quantity;
                    this.PriceSegments = configuration.priceSegments;
                    this.ListPriceSegments = configuration.listPriceSegments;
                    this.PriceSegmentsNoMargin = configuration.priceSegmentsNoMargin;
                    this.ListPriceSegmentsNoMargin = configuration.listPriceSegmentsNoMargin;
                    this.PriceSegmentsBeforePromotions = configuration.priceSegmentsBeforePromotions;
                    this.ListPriceSegmentsBeforePromotions = configuration.listPriceSegmentsBeforePromotions;
                    this.PriceParts = configuration.priceParts;
                    this.ListPriceParts = configuration.listPriceParts;
                    this.PricePartsNoMargin = configuration.pricePartsNoMargin;
                    this.ListPricePartsNoMargin = configuration.listPricePartsNoMargin;
                    this.PricePartsBeforePromotions = configuration.pricePartsBeforePromotions;
                    this.ListPricePartsBeforePromotions = configuration.listPricePartsBeforePromotions;
                    this.DiscountGroups = configuration.discountGroups;
                    this.DiscountGroupsNoMargin = configuration.discountGroupsNoMargin;
                    this.Title = configuration.title;
                    this.Description = configuration.description;
                    this.valid = configuration.valid;
                    this.attributes = configuration.attributes;

                    this.parameters = configuration.parameters;

                    this.height = configuration.height;
                    this.width = configuration.width;
                    this.couplings = configuration.couplings;
                    this.usedProfiles = configuration.usedProfiles;
                    this.windows = configuration.windows;
                    this.rollerShutters = configuration.rollerShutters;
                    this.sideProfiles = configuration.sideProfiles;
                    this.windowSills = configuration.windowSills;
                }
            }
        }
        this.configuratorsDataService = null;
    }
}
